import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Scanner from '../components/Scanner';

export default function Home() {
  const { me, logout } = useAuth();

  return (
    <div className="app-container">
      <header className="navbar">
        <div className="navbar-logo">Follower</div>
        <div className="navbar-actions">
          <span className="navbar-user">{me?.handle || 'your account'}</span>
          <button className="logout-button" type="button" onClick={logout}>
            Sign out
          </button>
        </div>
      </header>

      <main className="main-container">
        <h1 className="lead">Scan an account, see every appview it has joined, follow it on each one.</h1>
        <Scanner />
      </main>

      <footer className="footer">
        Reads public repositories · writes only follow records you approve ·{' '}
        <Link to="/preview">preview without signing in</Link>
      </footer>
    </div>
  );
}
